import { Component } from '@angular/core';
import { NavServiceService } from 'src/app/services/nav-service.service';

@Component({
  selector: 'app-supplier',
  templateUrl: './supplier.component.html',
  styleUrls: ['./supplier.component.css']
})
export class SupplierComponent {
  pageTitle: any = '';

  constructor(
    public navService: NavServiceService
  ){}

  ngOnInit(){
    this.navService.titleSub.subscribe(res => {
      // console.log(res);
      this.pageTitle = res;
    })
  }

}
